import { api } from "./api";

interface YearlySalesItem {
  month: string;
  count: number;
}

interface IYearlySalesResponse {
  data: YearlySalesItem[];
}

interface Executive {
  id: string;
  full_name: string;
}

interface IExecutivesResponse {
  results: Executive[];
}

interface Product {
  id: string;
  name: string;
}

interface IProductsResponse {
  data: Product[];
}

export const reportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getExecutiveSalesReportCards: builder.query<any, { id: string | null }>({
      query: ({ id }) => ({
        // url: `/${id}/executive-sales-report-cards/`,
        url: `/sales-report/dashboard/cards/`,
        method: "GET",
      }),
      providesTags: ["GetAllDashboardCount"],
    }),

    getSalesOverviewLineChart: builder.query<
      any,
      { executive_id?: string; start_date?: string; end_date?: string; finished_goods_id?: string | number; months_back?: string | number }
    >({
      query: ({ executive_id, start_date, end_date, finished_goods_id, months_back }) => ({
        url: `/sales-report/dashboard/line-chart/`,
        method: "GET",
        params: {
          executive_id,
          start_date,
          end_date,
          finished_goods_id,
          months_back,
        },
      }),
      providesTags: ["GetAllDashboardBarChartCount"],
    }),

    getYearlySalesCountBarChart: builder.query<
      IYearlySalesResponse,
      { id: string | null; year: string }
    >({
      query: ({ id, year }) => ({
        url: `/${id}/yearly-sales-count/?year=${year}`,
        method: "GET",
      }),
      providesTags: ["GetAllDashboardBarChartCount"],
    }),

    getSalesReportPieChart: builder.query<
      any,
      { id: string | null; year: string; month: string; product: string }
    >({
      query: ({ id, year, month, product }) => ({
        url: `/${id}/sales-report-charts/?year=${year}&month=${month}&product_name=${product}`,
        method: "GET",
      }),
      providesTags: ["GetAllDashboardPieChartCount"],
    }),
    // getExecutives: builder.query<any, void>({
    //   query: () => ({
    //     url: `/sales-report/executives/`,
    //     method: "GET",
    //   }),
    // }),
    getExecutivesDropdownFilter: builder.query<IExecutivesResponse, { query?: string; finished_goods_id?: string }>({
      query: (params) => ({
        url: `/sales-report/executives/`,
        method: "GET",
        params: params || undefined,
      }),
      providesTags: ["GetContactsById"],
    }),

    getProductsDropdownFilter: builder.query<IProductsResponse, { query?: string; executive_id?: string }>({
      query: (params) => ({
        url: `/sales-report/products/`,
        method: "GET",
        params: params || undefined,
      }),
      providesTags: ["GetAllDashboardPieChartCount"],
    }),

    getOrderStatusPieChart: builder.query<
      any,
      { executive_id?: string; start_date?: string; end_date?: string; finished_goods_id?: string | number }
    >({
      query: ({ executive_id, start_date, end_date, finished_goods_id }) => ({
        url: `/sales-report/dashboard/pie-chart/`,
        method: "GET",
        params: {
          executive_id,
          start_date, 
          end_date,
          finished_goods_id,
        },
      }),
      providesTags: ["GetAllDashboardPieChartCount"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetExecutiveSalesReportCardsQuery,
  useGetSalesOverviewLineChartQuery,
  useGetYearlySalesCountBarChartQuery,
  useGetSalesReportPieChartQuery,
  useGetOrderStatusPieChartQuery,
  useGetExecutivesQuery,
  useGetExecutivesDropdownFilterQuery,
  useGetProductsDropdownFilterQuery,
} = reportApi;
